import TCampaignsEdit from './index.vue';

TCampaignsEdit.install = app => {
  app.component(TCampaignsEdit.name, TCampaignsEdit);
};

export default TCampaignsEdit;
